import { render, staticRenderFns } from "./TripDeliveryDialog.vue?vue&type=template&id=0ae84563&scoped=true"
import script from "./TripDeliveryDialog.vue?vue&type=script&lang=js"
export * from "./TripDeliveryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae84563",
  null
  
)

export default component.exports